function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import Xt from "../models/backend-errors.js";
import ve from "../models/braze-event.js";
import { convertMsToSeconds as O, convertSecondsToMs as $t } from "../util/date-utils.js";
import c from "../common/event-logger.js";
import { isArray as z, isEqual as ii } from "../util/code-utils.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./storage-manager.js";
import h from "../util/request-header-utils.js";
import { LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT as Kt, MAX_RETRY_COUNT_PER_REQUEST as Ht } from "../common/constants.js";
import { getAlias as Yt } from "./utils.js";
import { readResponseHeaders as Jt } from "../util/net.js";

var Pt = /*#__PURE__*/function () {
  function Pt(t, e, i, s, r, n, o, a, h, u, l, c) {
    _classCallCheck(this, Pt);

    this.hn = t, this.C = e, this.Pa = i, this.Cs = s, this.T = r, this.B = n, this.an = o, this.La = a, this.Ta = h, this.Ra = u, this.appVersion = l, this.au = c, this.du = function (t) {
      return null == t ? "" : "".concat(t, " ");
    }, this.hn = t, this.C = e, this.Pa = i, this.Cs = s, this.T = r, this.B = n, this.an = o, this.La = a, this.Ta = h, this.Ra = u, this.appVersion = l, this.au = c, this.fu = ["npm"], this.vu = [];
  }

  _createClass(Pt, [{
    key: "H",
    value: function H(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = this.hn.ve(!i),
          n = r.Nr(),
          o = this.C.ft(s.gt.oc);
      ii(o, n) || (t.device = n), t.api_key = this.an, t.time = O(new Date().valueOf(), !0);
      var a = this.C.ft(s.gt.pu) || [],
          h = this.C.ft(s.gt.Ru) || "";
      this.fu.length > 0 && (!ii(a, this.fu) || h !== this.T.St()) && (t.sdk_metadata = this.fu), t.sdk_version = this.Ta, this.Ra && (t.sdk_flavor = this.Ra), t.app_version = this.appVersion, t.app_version_code = this.au, t.device_id = r.id;
      var u = this.Cs.getUserId();

      if (e && null !== u && (t.user_id = u), !u && !this.Pa.jh()) {
        var _e = Yt(this.C);

        _e && (t.alias = _e);
      }

      return t;
    }
  }, {
    key: "st",
    value: function st(t, e, i) {
      var s = e.auth_error,
          r = e.error;
      if (!s && !r) return !0;

      if (s) {
        var _e2;

        this.Pa.Jh();
        var _r = {
          errorCode: s.error_code
        };

        var _iterator = _createForOfIteratorHelper(i),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            z(_t) && "X-Braze-Auth-Signature" === _t[0] && (_r.signature = _t[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        t.respond_with && t.respond_with.user_id ? _r.userId = t.respond_with.user_id : t.user_id && (_r.userId = t.user_id);
        var n = s.reason;
        return n ? (_r.reason = n, _e2 = "due to ".concat(n)) : _e2 = "with error code ".concat(s.error_code, "."), this.Pa.jh() || (_e2 += ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'), N.error("SDK Authentication failed ".concat(_e2)), this.gu(t.events || [], t.attributes || []), this.Pa.Gh(_r), !1;
      }

      if (r) {
        var _i,
            _s = r;

        switch (_s) {
          case Xt.bu:
            return _i = "Received successful response with empty body.", c.ut(d.qu, {
              e: _i
            }), N.info(_i), !1;

          case Xt.Au:
            return _i = "Received successful response with invalid JSON", c.ut(d.qu, {
              e: _i + ": " + e.response
            }), N.info(_i), !1;

          case Xt.Du:
            _s = "The API key \"".concat(t.api_key, "\" is invalid for the baseUrl ").concat(this.La);
            break;

          case Xt.Tu:
            _s = "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
            break;

          case Xt.ku:
            _s = "No device identifier. Please contact support@braze.com";
        }

        N.error("Backend error: " + _s);
      }

      return !1;
    }
  }, {
    key: "yu",
    value: function yu(t, e, i, s) {
      return !!(t && 0 !== t.length || e && 0 !== e.length || i || s);
    }
  }, {
    key: "wu",
    value: function wu(t, e, i, s) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

      var n = [],
          o = function o(t) {
        return t || "";
      },
          a = o(this.Cs.getUserId());

      var u = this.Gr(t, e);
      var l = [],
          c = [];
      var d,
          f = null;

      if (i.length > 0) {
        var _t2 = [];

        var _iterator2 = _createForOfIteratorHelper(i),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e3 = _step2.value;

            if (d = _e3.Nr(), this.Pa.jh()) {
              if (a && !d.user_id) {
                f || (f = {}), f.events || (f.events = []), f.events.push(d);
                continue;
              }

              if (o(d.user_id) !== a) {
                c.push(d);
                continue;
              }
            }

            _t2.push(d);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        _t2.length > 0 && (u.events = _t2);
      }

      if (s.length > 0) {
        var _t3 = [];

        var _iterator3 = _createForOfIteratorHelper(s),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e4 = _step3.value;
            _e4 && (this.Pa.jh() && o(_e4.user_id) !== a ? l.push(_e4) : _t3.push(_e4));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        _t3.length > 0 && (u.attributes = _t3);
      }

      if (this.gu(c, l), u = this.H(u, !1, r), f) {
        f = this.H(f, !1, r);
        var _t4 = {
          requestData: f,
          headers: this.J(f, h.O.Nu)
        };
        n.push(_t4);
      }

      if (u && !this.yu(u.events, u.attributes, t, e)) return f ? n : null;
      var m = {
        requestData: u,
        headers: this.J(u, h.O.Nu)
      };
      return n.push(m), n;
    }
  }, {
    key: "gu",
    value: function gu(t, e) {
      if (t) {
        var _e5 = [];

        var _iterator4 = _createForOfIteratorHelper(t),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var i = _step4.value;

            var _t5 = ve.fromJson(i);

            _t5.time = $t(_t5.time), _e5.push(_t5);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.C.Vo(_e5);
      }

      if (e) {
        var _iterator5 = _createForOfIteratorHelper(e),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t6 = _step5.value;
            this.C.Cu(_t6);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "et",
    value: function et(t, e) {
      var i = "HTTP error ";
      null != t && (i += t + " "), i += e, N.error(i);
    }
  }, {
    key: "zr",
    value: function zr(t) {
      return c.ut(d.Su, {
        n: t
      });
    }
  }, {
    key: "Gr",
    value: function Gr(t, e, i) {
      var s = {};
      t && (s.feed = !0), e && (s.triggers = !0);
      var r = null != i ? i : this.Cs.getUserId();

      if (r && (s.user_id = r), !s.user_id && !this.Pa.jh()) {
        var _t7 = Yt(this.C);

        _t7 && (s.alias = _t7);
      }

      return s.config = {
        config_time: this.B.Et()
      }, {
        respond_with: s
      };
    }
  }, {
    key: "Bu",
    value: function Bu(t) {
      var e = new Date().valueOf();
      var i = Kt.toString();
      var s = h.zu(this.C, t);

      if (-1 !== s) {
        i = (e - s).toString();
      }

      return i;
    }
  }, {
    key: "J",
    value: function J(t, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var s = [["X-Braze-Api-Key", this.an]],
          r = this.Bu(e);
      s.push(["X-Braze-Last-Req-Ms-Ago", r]);
      var n = h.ju(this.C, e).toString();
      s.push(["X-Braze-Req-Attempt", n]);
      var o = !1;

      if (null != t.respond_with && t.respond_with.triggers && (s.push(["X-Braze-TriggersRequest", "true"]), o = !0), null != t.respond_with && t.respond_with.feed && (s.push(["X-Braze-FeedRequest", "true"]), o = !0), e === h.O.wi) {
        s.push(["X-Braze-ContentCardsRequest", "true"]);

        var _t8 = h.ju(this.C, h.O.wi);

        _t8 && !i || (_t8 = 1, h.Mu(this.C, h.O.wi, _t8));

        var _e6 = Math.max(0, _t8 - 1);

        s.push(["BRAZE-SYNC-RETRY-COUNT", _e6.toString()]), o = !0;
      }

      if (e === h.O.Le && (s.push(["X-Braze-FeatureFlagsRequest", "true"]), o = !0), o && s.push(["X-Braze-DataRequest", "true"]), this.Pa.jh()) {
        var _t9 = this.Pa.xh();

        null != _t9 && s.push(["X-Braze-Auth-Signature", _t9]);
      }

      return s;
    }
  }, {
    key: "Xu",
    value: function Xu(t, e, i, s) {
      var _this = this;

      var r = window.setTimeout(function () {
        N.info("Retrying rate limited ".concat(_this.du(s), "SDK request.")), _this.V(e, i, s);
      }, t);
      this.vu.push(r);
    }
  }, {
    key: "fo",
    value: function fo() {
      var _iterator6 = _createForOfIteratorHelper(this.vu),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var t = _step6.value;
          window.clearTimeout(t);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      this.vu = [];
    }
  }, {
    key: "V",
    value: function V(t, e, i, r) {
      if (!this.$u(i)) return N.info("".concat(this.du(i), "SDK request being rate limited.")), void ("function" == typeof r && r());
      var n = this.Fu();
      if (!n.Lu) return N.info("".concat(this.du(i), "SDK request being rate limited. Request will be retried in ").concat(Math.trunc(n.Eu / 1e3), " seconds.")), void this.Xu(n.Eu, t, e, i);
      this.C.Bt(s.gt.Ku, new Date().valueOf());
      var o = t.device;
      o && o.os_version instanceof Promise ? o.os_version.then(function (i) {
        t.device.os_version = i, e(n.Iu);
      }) : e(n.Iu);
    }
  }, {
    key: "Pu",
    value: function Pu(t) {
      var e = t ? Jt(t) : null;
      if (!e || !e["retry-after"]) return null;
      var i = e["retry-after"];
      if (isNaN(i) && !isNaN(Date.parse(i))) return {
        type: "date",
        value: Date.parse(i)
      };
      if (!isNaN(parseFloat(i.toString()))) return {
        type: "timestamp",
        value: 1e3 * parseFloat(i.toString())
      };
      {
        var _t10 = "Received unexpected value for retry-after header in /sync response";
        c.ut(d.qu, {
          e: _t10 + ": " + i
        });
      }
      return null;
    }
  }, {
    key: "rt",
    value: function rt(t, e, i, s, r, n) {
      var _this2 = this;

      if (h.ju(this.C, i) >= Ht) return;
      var o;
      n = n || 0;
      var a = this.Pu(t);
      r();

      var u = function u(t) {
        var r = window.setTimeout(function () {
          e();
        }, t);
        s(r), h.Uu(_this2.C, i);
      };

      if (a && !isNaN(a.value)) {
        switch (a.type) {
          case "date":
            o = a.value - new Date().getTime() + n, o < 0 && e();
            break;

          case "timestamp":
            o = a.value + n;
        }

        u(o);
      } else n ? u(n) : h.vi(this.C, i);
    }
  }, {
    key: "xu",
    value: function xu(t) {
      var e;
      null === (e = this.C) || void 0 === e || e.Bt(s.gt.Hu, t);
    }
  }, {
    key: "Ou",
    value: function Ou(t, e) {
      var i = this.Gu();
      null == i && (i = {}), i[t] = e, this.C.Bt(s.gt._u, i);
    }
  }, {
    key: "Wu",
    value: function Wu() {
      var t;
      return null === (t = this.C) || void 0 === t ? void 0 : t.ft(s.gt.Hu);
    }
  }, {
    key: "Gu",
    value: function Gu() {
      var t;
      return null === (t = this.C) || void 0 === t ? void 0 : t.ft(s.gt._u);
    }
  }, {
    key: "Yu",
    value: function Yu(t, e, i, s) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var n;

      if (r) {
        var _t11 = this.Gu();

        n = null == _t11 || isNaN(_t11[r]) ? e : _t11[r];
      } else n = this.Wu(), (null == n || isNaN(n)) && (n = e);

      var o = (t - s) / 1e3;
      return n = Math.min(n + o / i, e), n;
    }
  }, {
    key: "Ju",
    value: function Ju(t, e) {
      return Math.max(0, (1 - t) * e * 1e3);
    }
  }, {
    key: "Qu",
    value: function Qu(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var i, r, n, o, a;
      var u = {
        Lu: !0,
        Iu: -1,
        Eu: 0
      };
      if (null == t && (t = !0), !t && !e) return u;
      var l,
          c,
          d = null;
      if (t) d = null === (i = this.C) || void 0 === i ? void 0 : i.ft(s.gt.Ku);else {
        var _t12 = h.Vu(this.C);

        if (null == _t12 || null == _t12[e]) return u;
        d = _t12[e];
      }
      if (null == d || isNaN(d)) return u;
      if (t ? (l = (null === (r = this.B) || void 0 === r ? void 0 : r.Zu()) || -1, c = (null === (n = this.B) || void 0 === n ? void 0 : n.tl()) || -1) : (l = (null === (o = this.B) || void 0 === o ? void 0 : o.el(e)) || -1, c = (null === (a = this.B) || void 0 === a ? void 0 : a.il(e)) || -1), -1 === l || -1 === c) return u;
      var f = new Date().valueOf();
      var m = this.Yu(f, l, c, d, e);
      return m < 1 ? (u.Lu = !1, u.Eu = this.Ju(m, c), u) : (m = Math.trunc(m) - 1, u.Iu = m, t ? this.xu(m) : this.Ou(e, m), u);
    }
  }, {
    key: "Fu",
    value: function Fu() {
      return this.Qu(!0);
    }
  }, {
    key: "$u",
    value: function $u(t) {
      var e = this.Qu(!1, t);
      return !(e && !e.Lu);
    }
  }, {
    key: "it",
    value: function it() {
      this.Pa.it();
    }
  }, {
    key: "Z",
    value: function Z() {
      return this.La;
    }
  }, {
    key: "addSdkMetadata",
    value: function addSdkMetadata(t) {
      var _iterator7 = _createForOfIteratorHelper(t),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var e = _step7.value;
          -1 === this.fu.indexOf(e) && this.fu.push(e);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }]);

  return Pt;
}();

export { Pt as default };